'use strict';

import $ from 'jquery';
import {Fancybox} from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css"

class PopupManager {
    constructor(config = {}) {
        this.config = {
            touch: false,
            autoFocus: false,
            smallBtn: true,
            toolbar: false,
            modal: false,
            clickSlide: false,
            clickOutside: false,
            closeExisting: true,
            hideScrollbar: false,
            mobile: {
                clickSlide: (current) => current.type === "image" ? "toggleControls" : false
            },
            ...config
        };
    }

    getInstance() {
        let instance = $.fancybox.getInstance();
        if (!instance) {
            this.loading();
            instance = $.fancybox.getInstance();
        }
        return instance;
    }

    loading(args = {}) {
        //this.close();
        Fancybox.show([{
            type: "html",
            content: '<div class="f-spinner"></div>' // Manual spinner if needed
        }]);
        /*$.fancybox.open(
            '<div class="fancybox-loading"></div>',
            {...$.fancybox.defaults, ...this.config, ...args}
        );*/
    }

    setContent(content) {
        const instance = this.getInstance();
        instance.current.$slide.trigger("onReset");
        instance.setContent(instance.current, content);
    }

    error() {
        const instance = this.getInstance();
        instance.setError(instance.current);
    }

    close() {
        Fancybox.close();
    }
}

window.popupManager = new PopupManager();
